/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishing Position Heatmap`)
};

const es_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de Posiciones de Llegada`)
};

const de_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielpositions-Heatmap`)
};

const nl_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishpositie-heatmap`)
};

const fr_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte thermique des positions d’arrivée`)
};

const it_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mappa termica posizioni di arrivo`)
};

const pt_br2_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de calor de posição de chegada`)
};

const pt_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de posição de chegada`)
};

const ja_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィニッシュポジションヒートマップ`)
};

const zh_f1_profile_chart_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完赛名次热图`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_chart_finish_heatmap = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_chart_finish_heatmap(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_chart_finish_heatmap", locale)
	if (locale === "en") return en_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "es") return es_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "de") return de_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "nl") return nl_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "fr") return fr_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "it") return it_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "pt") return pt_f1_profile_chart_finish_heatmap(inputs)
	if (locale === "ja") return ja_f1_profile_chart_finish_heatmap(inputs)
	return zh_f1_profile_chart_finish_heatmap(inputs)
};